var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStatusPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0000610352,
    width: 24,
    height: 24,
    rx: 8,
    fill: "#FFDE31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 18.75C8.11713 18.75 4.99994 15.6328 4.99994 11.75C4.99994 7.89453 8.11713 4.75 11.9999 4.75C15.8554 4.75 18.9999 7.89453 18.9999 11.75C18.9999 15.6328 15.8554 18.75 11.9999 18.75ZM11.3437 11.75C11.3437 11.9688 11.4531 12.1875 11.6171 12.2969L14.2421 14.0469C14.5429 14.2656 14.9531 14.1836 15.1445 13.8828C15.3632 13.582 15.2812 13.1719 14.9804 12.9531L12.6562 11.4219V8.03125C12.6562 7.67578 12.3554 7.375 11.9726 7.375C11.6171 7.375 11.3163 7.67578 11.3163 8.03125L11.3437 11.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusPending);
export default __webpack_public_path__ + "static/media/icon-status-pending.f392baac963d1cba92ec2caec0410a94.svg";
export { ForwardRef as ReactComponent };